import { ListObjectsCommandInput } from "@aws-sdk/client-s3";
import { BlogTreeNode } from "@model/blog-tree-node";
import { S3ObservableFactory } from "aws/aws-observable";
import { map } from "rxjs";
import { FileManager } from "utils/file-manager";

export type BlogTreeRequest = {
  s3Request: ListObjectsCommandInput;
  item: BlogTreeNode;
};

export const getBlogList = (request: BlogTreeRequest) => {
  const s3ObservableFactory = new S3ObservableFactory();
  const listObjectsV2 = s3ObservableFactory.listObjectsV2();
  return listObjectsV2(request!.s3Request).pipe(
    map(response => {
      const parent = request!.item;
      const itemsLevel = !parent ? 0 : parent.level + 1;
      const emptyFolders = { assets: [] as BlogTreeNode[], blogs: [] as BlogTreeNode[] };
      const { assets, blogs } = !response
        ? emptyFolders
        : response.data?.CommonPrefixes?.reduce((acc, y) => {
          const node = {
            open: false,
            name: !parent ? y.Prefix : y.Prefix?.replace(parent?.prefix, ''),
            prefix: y.Prefix,
            leastNode: false,
            parent: parent,
            level: itemsLevel
          } as BlogTreeNode;

          return y.Prefix?.endsWith('.assets/')
            ? { ...acc, assets: [...acc.assets, node], blogs: acc.blogs }
            : { ...acc, assets: acc.assets, blogs: [...acc.blogs, node] };
        }, emptyFolders) ?? emptyFolders;

      const files = !response
        ? [] as BlogTreeNode[]
        : response.data?.Contents?.map(y => ({
          open: false,
          name: !parent ? y.Key : y.Key?.replace(parent?.prefix, ''),
          prefix: parent?.prefix,
          parent: parent,
          leastNode: true,
          level: itemsLevel
        } as BlogTreeNode)) ?? [] as BlogTreeNode[];
      const editorFiles = files.filter(x => !!x && !!FileManager.getEditorType(x.name));
      const usedAssets = new Set();

      const groupedFiles = files.reduce((acc, f) => {
        const editorType = FileManager.getEditorType(f!.name);
        if (!editorType || editorType === 'image') {
          // find group
          const efi = editorFiles.findIndex(ef => f!.name.startsWith(ef!.name) && f!.name !== ef!.name);
          if (efi >= 0) {
            const editorFile = editorFiles[efi];
            if (editorFile) {
              const assetName = editorFile.name.substring(0, editorFile.name.length - (FileManager.getFileExtension(FileManager.getEditorType(editorFile.name)!)?.length ?? 0)) + '.assets';
              const assetAdded = usedAssets.has(assetName);
              editorFile.secondaryItems = [...(editorFile.secondaryItems ?? []), f!.name.replace(editorFile.name, ''), ...(!assetAdded && assets.findIndex(asset => asset?.name === assetName) ? [/*'>'*/] : [])];
            }
            return acc;
          }
        }
        return [...acc, f];
      }, [] as BlogTreeNode[]);
      return { parent: parent, resultItems: [...blogs, ...groupedFiles.filter(f => f?.name !== "").sort((x, y) => (y?.secondaryItems?.length ?? 0) - (x?.secondaryItems?.length ?? 0))] };
    })
  );
};
